import {
  DISPLAY_SESSION_EXPIRED_MODAL,
  HIDE_SESSION_EXPIRED_MODAL,
  TURN_OFF_LOADING_ACTION,
  TURN_ON_LOADING_ACTION,
  LOAD_TENANT_STYLES,
  STORE_PRODUCT_URL,
  TOGGLE_PASSWORD_MODE,
  DISPLAY_ON_BOARDING,
  SELECT_MENU_SECTION,
  SELECT_MENU_SCREEN_ID,
  SECTIONS_MENU,
  SAVE_USER_DATA,
  SAVE_TENANT_LANGUAGES,
  SAVE_SEARCH_TEXT,
  SAVE_SPONSORS,
  SAVE_INTERFACE_URLS,
  SAVE_LEGAL,
  SELECTED_SECTION,
  SAVE_RULES,
  CONTENT_HASH,
  CONTENT_TYPE,
  SAVE_CONTENT,
  SAVE_CONTENT_PERMISSIONS,
  USER_URL_AVATAR,
  SAVE_LANGUAGE_SELECTED, SAVE_TENANT_SHOW_PREVIEWS,
  USER_LOGIN, SAVE_PRODUCTS,
  SAVE_TRANSLATIONS,
  SAVE_TUTORIAL_URL,
  SAVE_LEGAL_TEXT,
  SAVE_NOTIFICATIONS,
  SAVE_IMAGES,
  SAVE_PROFILE_MENU_VISIBLE,
  SAVE_MENU_DISPLAY,
  SAVE_INTERFAZ_ID,
  SAVE_PLAYER_VERSION,
  SAVE_CARD_FIELDS
} from "../actions/actionTypes";
import { LOCAL_STORAGE_KEY__SKIP_ONBOARDING, MENU_DISPLAY_DEFAULT } from "../Utils/Constants";

const skipOnBoarding = localStorage.getItem(LOCAL_STORAGE_KEY__SKIP_ONBOARDING);

const INITIAL_STATE = {
  loading: true,
  isSessionExpired: false,
  tenantStyles: {},
  productURL: null,
  passwordMode: false,
  onBoarding: JSON.parse(skipOnBoarding),
  sectionSelected: null,
  menuSections: [],
  userData: {},
  userLogin: null,
  tenantLanguages: [],
  searchText: "",
  sponsors: [],
  interfaceUrls: {},
  legal: null,
  rules: null,
  contentHash: null,
  content: null,
  contentPermissions: null,
  selectedScreenId: null,
  selectedSection: null,
  contentType: null,
  userURLAvatar: null,
  previews: false,
  translations: [],
  products: [],
  images: [],
  profileMenuVisible: false,
  menuDisplay: MENU_DISPLAY_DEFAULT,
  interfazId: null,
  playerVersion: null,
  // OTT-1966: campos de la tarjeta de resultado en /buscar; `null` hasta que responda /interfaz,
  // que BuscarPage/ResultCard tratan como "aplicar el valor por defecto" (distinto de la cadena
  // vacía, que si es un valor real de card_fields significa "solo título").
  cardFields: null
};

function commonState(state = INITIAL_STATE, action) {
  switch (action.type) {
    case TURN_ON_LOADING_ACTION: {
      return { ...state, loading: true };
    }
    case TURN_OFF_LOADING_ACTION: {
      return { ...state, loading: false };
    }
    case DISPLAY_SESSION_EXPIRED_MODAL: {
      return { ...state, isSessionExpired: true };
    }
    case HIDE_SESSION_EXPIRED_MODAL: {
      return { ...state, isSessionExpired: false };
    }
    case LOAD_TENANT_STYLES: {
      return { ...state, tenantStyles: action.data };
    }
    case STORE_PRODUCT_URL: {
      return { ...state, productURL: action.data };
    }
    case TOGGLE_PASSWORD_MODE: {
      return { ...state, passwordMode: !state.passwordMode };
    }
    case DISPLAY_ON_BOARDING: {
      return { ...state, onBoarding: action.data };
    }
    case SELECT_MENU_SECTION: {
      return { ...state, sectionSelected: action.data };
    }
    case SELECT_MENU_SCREEN_ID: {
      return { ...state, selectedScreenId: action.data };
    }
    case SELECTED_SECTION: {
      return { ...state, selectedSection: action.data };
    }
    case SECTIONS_MENU: {
      return { ...state, sectionsMenu: action.data };
    }
    case SAVE_INTERFAZ_ID: {
      return { ...state, interfazId: action.data };
    }
    case SAVE_CARD_FIELDS: {
      return { ...state, cardFields: action.data };
    }
    case SAVE_USER_DATA: {
      return { ...state, userData: action.data };
    }
    case USER_LOGIN: {
      return { ...state, userLogin: action.data };
    }
    case SAVE_TENANT_LANGUAGES: {
      return { ...state, tenantLanguages: action.data };
    }
    case SAVE_TENANT_SHOW_PREVIEWS: {
        return { ...state, previews: action.data };
    }
    case SAVE_SEARCH_TEXT: {
      return { ...state, searchText: action.data };
    }
    case SAVE_SPONSORS: {
      return { ...state, sponsors: action.data };
    }
    case SAVE_INTERFACE_URLS: {
      return { ...state, interfaceUrls: action.data };
    }
    case SAVE_LEGAL: {
      return { ...state, legal: action.data };
    }
    case SAVE_RULES: {
      return { ...state, rules: action.data };
    }
    case CONTENT_HASH: {
      return { ...state, contentHash: action.data };
    }
    case CONTENT_TYPE: {
      return { ...state, contentType: action.data };
    }
    case SAVE_CONTENT: {
      return { ...state, content: action.data};
    }
    case SAVE_CONTENT_PERMISSIONS: {
      return { ...state, contentPermissions: action.data };
    }
    case USER_URL_AVATAR: {
      return { ...state, userURLAvatar: action.data };
    }
    case SAVE_LANGUAGE_SELECTED: {
      return { ...state, languageSelected: action.data };
    }
    case SAVE_PRODUCTS: {
      return { ...state, products: action.data };
    }
    case SAVE_TRANSLATIONS: {
      return { ...state, translations: action.data};
    }
    case SAVE_TUTORIAL_URL: {
      return { ...state, tutorialUrl: action.data };
    }
    case SAVE_LEGAL_TEXT: {
      return { ...state, legalText: action.data };
    }
    case SAVE_NOTIFICATIONS: {
      return { ...state, notifications: action.data };
    }
    case SAVE_IMAGES: {
      return { ...state, images: action.data };
    }
    case SAVE_PROFILE_MENU_VISIBLE: {
      return { ...state, profileMenuVisible: action.data };
    }
    case SAVE_MENU_DISPLAY: {
      return { ...state, menuDisplay: action.data };
    }
    case SAVE_PLAYER_VERSION: {
      return { ...state, playerVersion: action.data };
    }
    default:
      return state;
  }
}

export default commonState;
